export { default as EmailValidator } from './EmailValidator';
